/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
import { callApiServiceCommon } from '../service-common';

const upSellApi = process.env.REACT_APP_UPSELL_API;

export function* getProductsInCollectionService(data) {
  const payload = {
    method: 'GET',
    url: `${upSellApi}upsell/get-collection-settings-call-new`,
    params: {
      collectsId: JSON.stringify(data.id)
    }
  };
  return yield callApiServiceCommon(payload);
}
